import React from 'react';
export const services = [{
  id: '101',
  mdaId: 'mda-001',
  name: 'Tax Clearance Certificate',
  description: 'Official certificate confirming that your taxes are up to date with the state government.',
  fee: 2500,
  processingTime: '3-5 working days',
  requirements: ['Valid ID Card', 'Proof of Tax Payment for the last 3 years', 'Passport Photograph']
}, {
  id: '102',
  mdaId: 'mda-002',
  name: 'Business Permit Renewal',
  description: 'Annual renewal of your business operation permit within Edo State.',
  fee: 5000,
  processingTime: '5-7 working days',
  requirements: ['Previous Business Permit', 'Proof of Address', 'Tax Clearance Certificate']
}, {
  id: '201',
  mdaId: 'mda-004',
  name: 'Health Facility Registration',
  description: 'Registration of health facilities including hospitals, clinics, and pharmacies.',
  fee: 15000,
  processingTime: '10-14 working days',
  requirements: ['Medical License', 'Building Approval', 'Staff Qualification Documents', 'Facility Inspection Report']
}, {
  id: '301',
  mdaId: 'mda-005',
  name: 'Vehicle Registration',
  description: 'Register your vehicle with the Edo State Motor Vehicle Administration Agency.',
  fee: 7500,
  processingTime: '3-5 working days',
  requirements: ['Vehicle Purchase Receipt', 'Proof of Identity', 'Proof of Address', 'Vehicle Inspection Report']
}, {
  id: '401',
  mdaId: 'mda-003',
  name: 'Certificate of Occupancy',
  description: 'Official document confirming ownership rights to a property in Edo State.',
  fee: 50000,
  processingTime: '30-45 working days',
  requirements: ['Land Survey Plan', 'Proof of Ownership', 'Tax Clearance Certificate', 'Building Approval Plans']
}];
export const mdas = [{
  id: 'mda-001',
  name: 'Edo State Internal Revenue Service',
  description: 'Responsible for tax administration and revenue collection in Edo State.',
  logoUrl: 'https://via.placeholder.com/50'
}, {
  id: 'mda-002',
  name: 'Ministry of Commerce and Industry',
  description: 'Oversees business regulations, trade, and industrial development in Edo State.',
  logoUrl: 'https://via.placeholder.com/50'
}, {
  id: 'mda-003',
  name: 'Ministry of Lands and Surveys',
  description: 'Manages land administration, surveys, and property registration in Edo State.',
  logoUrl: 'https://via.placeholder.com/50'
}, {
  id: 'mda-004',
  name: 'Ministry of Health',
  description: 'Responsible for healthcare services, regulations, and health facility oversight.',
  logoUrl: 'https://via.placeholder.com/50'
}, {
  id: 'mda-005',
  name: 'Motor Vehicle Administration Agency',
  description: 'Handles vehicle registration, licensing, and related services in Edo State.',
  logoUrl: 'https://via.placeholder.com/50'
}];